<template>
  <div style="width: 80%">
    <el-form :model="form" label-width="auto" style="max-width: 600px">
      <el-form-item label="品名">
        <el-input v-model="form.pm" />
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="form.bt" />
      </el-form-item>
      <el-form-item label="价格">
        <el-input v-model="form.jg" />
      </el-form-item>
      <el-form-item label="特点">
        <el-input v-model="form.td" />
      </el-form-item>
      <el-form-item label="净含量">
        <el-input v-model="form.jhl" />
      </el-form-item>
      <el-form-item label="包装">
        <el-input v-model="form.bz" />
      </el-form-item>
      <el-form-item label="产地">
        <el-input v-model="form.cd" />
      </el-form-item>
      <el-form-item label="保质日期">
        <el-input v-model="form.bzrq" />
      </el-form-item>
      <el-form-item label="食用方法">
        <el-input v-model="form.syff" />
      </el-form-item>
      <el-form-item label="配料表">
        <el-input v-model="form.plb" type="textarea" />
      </el-form-item>
      <el-form-item label="致敏物质">
        <el-input v-model="form.zmwz" />
      </el-form-item>
      <el-form-item label="贮存条件">
        <el-input v-model="form.zctj" />
      </el-form-item>
      <el-form-item label="温馨提示">
        <el-input v-model="form.wxts" type="textarea" />
      </el-form-item>
      <el-upload
        v-model:file-list="fileList"
        action="ok"
        :auto-upload="false"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        multiple
      >
        <el-icon>
          添加
          <Plus />
        </el-icon>
      </el-upload>

      <el-dialog v-model="dialogVisible">
        <img w-full :src="dialogImageUrl" alt="Preview Image" />
      </el-dialog>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">新增</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import axios from "axios";
import { ElLoading, ElMessage } from "element-plus";

const dialogImageUrl = ref("");
const dialogVisible = ref(false);

var form = reactive({
  pm: "",
  bt: "",
  jg: "",
  td: "",
  jhl: "",
  bz: "",
  cd: "",
  bzrq: "",
  syff: "",
  plb: "",
  zmwz: "",
  zctj: "",
  wxts: "",
  tp: "",
  zh: "",
});

export default {
  name: "HomeView",
  data() {
    return {
      form,
      dialogImageUrl,
      dialogVisible,
      fileList: [],
      zh: sessionStorage.getItem("zh"),
    };
  },
  methods: {
    async onSubmit() {
      var that = this;

      console.log("submit!");
      console.log(this.form);
      if (this.fileList.length == 0) {
        return ElMessage({
          message: "请先上传图片！",
          grouping: true,
          type: "warning",
        });
      }
      /*
            if (this.form.pm.length == 0 || this.form.bt.length == 0 || this.form.jg.length == 0 || this.form.td.length == 0 || this.form.jhl.length == 0 || this.form.bz.length == 0 ||
                this.form.cd.length == 0 || this.form.bzrq.length == 0 || this.form.syff.length == 0 || this.form.plb.length == 0 || this.form.zmwz.length == 0 || this.form.zctj.length == 0 ||
                this.form.wxts.length == 0
            ) {
                return ElMessage({
                    message: '必填项不能为空！',
                    grouping: true,
                    type: 'warning',
                });
            }
            */
           console.log("fileList:", this.fileList);
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await this.upaction(); // 等待上传图片完成
      console.log("我的上传图片的真实路径", this.fileList);
      return;
      var pictureslist = [];

      for (let i = 0; i < this.fileList.length; i++) {
        pictureslist.push(this.fileList[i].url);
      }

      // 将合并后的数组转换为 JSON 字符串
      var jsonString = JSON.stringify(pictureslist);

      console.log("转换后的 JSON 字符串", jsonString);

      // 将转换后的 JSON 字符串赋值给 this.form.tp
      this.form.tp = jsonString;
      console.log("待上传表单数据", form);
      this.form.zh = this.zh;

      // 上传服务器
      const res = await axios.post(
        "/api/addproduct", // 请求后端的 URL
        that.form,
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
            "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
          },
        }
      );
      console.log("请求后", res);
      loadingInstance.close();
      ElMessage({
        message: "上传成功！",
        grouping: true,
        type: "success",
      });
    },
    handlePictureCardPreview(uploadFile) {
      console.log(uploadFile);
      this.dialogImageUrl = uploadFile.url;
      this.dialogVisible = true;
    },

    handleRemove(file, fileList) {
      console.log(file);
      console.log(fileList);
    },

    // 上传图片
    async upaction() {
      var that = this;
      for (let i = 0; i < this.fileList.length; i++) {
        var src = await this.uploadFile(this.fileList[i]);
        this.fileList[i].url = src;
      }
    },
    base64ToBlob(base64Data, contentType = "") {
      const byteCharacters = atob(base64Data);
      const byteArrays = [];
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }
      return new Blob([new Uint8Array(byteArrays)], { type: contentType });
    },
    async uploadFile(file) {
        /*
      console.log("uploadFile中，未编码url为", file.url);
      const newbasesrc = await this.getdata(file);
      console.log("编码url后", newbasesrc);
*/
      const formData = new FormData();
      //const fileBlob = this.base64ToBlob(newbasesrc.split(",")[1], "image/png");

      // ✅ 正确：使用 fileBlob，并指定文件名（可选）
      formData.append("file", file.raw);
      try {
        const res = await axios.post(
          "/fwq/upload/file", // 请求后端的 URL
          //{ file: newbasesrc },
          formData,
          {
            headers: {
              apikey: "37A3285C065822FA75B791F14AC9AE40",
              //"Content-Type": "multipart/form-data;charset=utf-8",
            },
          }
        );
        //console.log(res);
      } catch (error) {
        console.error("代理请求失败:", error);
      }
      return "";
    },
    async getdata(file) {
      // 使用 FileReader 将文件转换为 base64 编码字符串
      console.log("getdata函数中，准备转化", file);
      const base64String = await this.readFileAsBase64(file);
      console.log("获得编码", base64String);
      return base64String;
    },

    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          // 将文件转换为 base64 编码
          const base64String = event.target.result;
          resolve(base64String);
        };
        reader.onerror = reject;
        // 读取文件内容并转换为 base64 编码字符串
        reader.readAsDataURL(file.raw);
      });
    },
  },
};
</script>
